<div class="d-wrapper">
    <div class="d-title">Angebot</div>
    <div class="dg-info">
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Reisezeitraum:</span>
            <span multilang>{{datas?.hinflugs?.[0]?.startDate | date:'dd.MM.yyyy'}} {{ datas?.ruckflugs?.length > 0
                ? '
                - ' +
                (datas?.ruckflugs[0].startDate | date:'dd.MM.yyyy'): ''}}</span>
        </div>
        <div class="dg-info-item">
            <span multilang [class.dg-info-item-first]="deskMode"
                [class.dg-info-item-first-mobile]="!deskMode">Routing:</span>
            <span multilang>{{datas?.hinflugs?.[0]?.departureAirport?.name}} -
                {{datas?.hinflugs?.[datas.hinflugs.length
                -
                1]?.arrivalAirport?.name}}{{ datas?.ruckflugs?.length > 0 ? (' - ' +
                datas?.ruckflugs?.[datas.hinflugs.length - 1]?.arrivalAirport?.name): ''}}</span>
        </div>
    </div>

    <ng-container *ngIf="datas?.extracomment?.length > 0">
        <div class="d-info-prc">
            <span multilang class="c-item-title">Extra info</span>
        </div>
        <div class="d-info-text">
            <pre class="ml pree">{{datas?.extracomment}}</pre>
        </div>
    </ng-container>

    <div class="d-info-prc">
        <span multilang>Ihr Flug</span>
        <span multilang>Gesamtpreis: {{datas?.price | number:'1.2-2'}} {{datas?.currency}}</span>
    </div>

    <div class="d-info-text">
        <p>
            Zwischenverkauf, Preis- und Flugzeitenänderungen vorbehalten.<br>
            Ein Großteil der günstigen Flugtarife sind nur bedingt, und wenn, nur gegen Gebühr umbuchbar oder
            stornierbar. Diese Gebühren können bis zu
            100% des Flugpreises betragen. Genaue Bedingungen können Sie bei Ihrem Reisebüro oder Reiseveranstalter
            erfragen.
        </p>
    </div>

    <ng-container *ngIf="deskMode else infomobilemode">
        <ng-container *ngTemplateOutlet="finfo; context:{flugs: datas?.hinflugs}"></ng-container>
        <div class="mt">
            <ng-container *ngTemplateOutlet="finfo context:{flugs: datas?.ruckflugs}"></ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="datas?.pricePerAdult?.length > 0; else onePrc">
        <div class="f-prc-wrapper">
            <span multilang class="f-prc-title">Preisübersicht</span>
            <table class="prc-table">
                <tr>
                    <td class="b-bottom" align="right">Anz</td>
                    <td class="b-bottom" align="right">Pax</td>
                    <td class="b-bottom" align="right">Preis</td>
                    <td class="b-bottom" align="right"></td>
                </tr>
                <tr>
                    <td class="b-bottom" align="right">{{datas?.adult}}</td>
                    <td class="b-bottom" align="right">ADT</td>
                    <td class="b-bottom" align="right">{{datas?.pricePerAdult | number:'1.2-2'}} {{datas?.currency}}
                    </td>
                    <td class="b-bottom" align="right">{{datas?.priceTotalAdult | number:'1.2-2'}} {{datas?.currency}}
                    </td>
                </tr>
                <ng-container *ngIf="datas?.pricePerChildren?.length > 0;">
                    <tr>
                        <td class="b-bottom" align="right">{{datas?.childrenCount}}</td>
                        <td class="b-bottom" align="right">CHD</td>
                        <td class="b-bottom" align="right">{{datas?.pricePerChildren | number:'1.2-2'}}
                            {{datas?.currency}}</td>
                        <td class="b-bottom" align="right">{{datas?.priceTotalChildren | number:'1.2-2'}}
                            {{datas?.currency}}</td>
                    </tr>
                </ng-container>
                <ng-container *ngIf="datas?.infantcount?.length > 0;">
                    <tr>
                        <td class="b-bottom" align="right">{{datas?.infantcount}}</td>
                        <td class="b-bottom" align="right">INF</td>
                        <td class="b-bottom" align="right">{{datas?.pricePerInfant | number:'1.2-2'}}
                            {{datas?.currency}}</td>
                        <td class="b-bottom" align="right">{{datas?.priceTotalInfant | number:'1.2-2'}}
                            {{datas?.currency}}</td>
                    </tr>
                </ng-container>
                <tr>
                    <td colspan="3" align="right" style="font-weight: 400;">Gesamtpreis:</td>
                    <td>{{datas?.price | number:'1.2-2'}} {{datas?.currency}}</td>
                </tr>
            </table>
        </div>
    </ng-container>

    <div class="f-btn-wrapper">
        <button class="f-btn" matRipple (click)="sendAnmeldung()">Anfrage senden</button>
    </div>
</div>

<ng-template #onePrc>
    <span multilang class="mt oneprc">PAX: {{datas?.pax}}</span>
    <span multilang class="mt oneprc">Gesamtpreis: {{datas?.price | number:'1.2-2'}} {{datas?.currency}}</span>
</ng-template>

<ng-template #finfo let-flugs="flugs">
    <ng-container *ngIf="flugs?.length > 0">
        <div class="f-info-wrapper">
            <div class="f-info-a">
                <span multilang>{{flugs[0].departureAirport?.name}}</span>
                <mat-icon class="f-info-a-icon">flight</mat-icon>
                <span multilang>{{flugs[flugs.length - 1].arrivalAirport?.name}}</span>
                <span multilang class="f-stopps"><span multilang class="it">Stopps:</span> {{flugs.length -
                    1}}</span>
            </div>
            <ng-container *ngFor="let fl of flugs">
                <div class="f-info-date">
                    <span multilang>{{fl.startDate | date:'EEE, dd.MM.yyyy'}}</span>
                    <span multilang>{{fl.carrier}} ({{fl.flightNumber}})</span>
                    <span multilang class="w-20">{{fl.departureAirport?.name}}
                        ({{fl.departureAirport?.code}})</span>
                    <span multilang class="w-20">{{fl.arrivalAirport?.name}} ({{fl.arrivalAirport?.code}})</span>
                    <div class="t-wrapper">
                        <span multilang class="ml">{{fl.startDate | date:'HH:mm'}}</span>
                        <div class="ml a-time">
                            <span multilang>{{fl.endDate | date:'HH:mm'}}</span>
                            <ng-container *ngIf="fl.plusDay > 0">
                                <span multilang class="a-time-p">+{{fl.plusDay}}</span>
                            </ng-container>
                        </div>
                        <div class="ml a-time w-40">
                            <span multilang><span multilang class="it">Dauer:</span> {{fl.dauer}} h</span>
                            <ng-container *ngIf="fl.waitTime?.length > 0">
                                <span multilang class="a-time-p">Transfer {{fl.arrivalAirport?.code}}:
                                    {{fl.waitTime}}
                                    h</span>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="f-b-info">
                    <span multilang><span multilang class="it">Kabinenklasse:</span> {{fl.cabinClass}}</span>
                    <span multilang class="ml"><span multilang class="it">Gepäck:</span> {{fl.gepack}}</span>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #infomobilemode>
    <ng-container *ngTemplateOutlet="finfoMobile; context:{flugs: datas?.hinflugs}"></ng-container>
    <div class="mt">
        <ng-container *ngTemplateOutlet="finfoMobile context:{flugs: datas?.ruckflugs}"></ng-container>
    </div>
</ng-template>


<ng-template #finfoMobile let-flugs="flugs">
    <ng-container *ngIf="flugs?.length > 0">
        <div class="f-info-wrapper">
            <div class="f-info-a">
                <span multilang>{{flugs[0].departureAirport?.name}}</span>
                <mat-icon class="f-info-a-icon">flight</mat-icon>
                <span multilang>{{flugs[flugs.length - 1].arrivalAirport?.name}}</span>
                <!--span class="f-stopps"><span  multilang   class="it">Stopps:</span> {{flugs.length - 1}}</span-->
            </div>
            <ng-container *ngFor="let fl of flugs;let k=index">
                <div class="f-info-date-mobile">
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Von</span>
                        <span multilang>{{fl.departureAirport?.name}} ({{fl.departureAirport?.code}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Nach</span>
                        <span multilang>{{fl.arrivalAirport?.name}} ({{fl.arrivalAirport?.code}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Datum</span>
                        <span multilang>{{fl.startDate | date:'EEEE, dd.MM.yyyy'}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Flug</span>
                        <span multilang>{{fl.carrier}} ({{fl.flightNumber}})</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Abflug</span>
                        <span multilang>{{fl.startDate | date:'HH:mm'}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Ankunft</span>
                        <span multilang>{{fl.endDate | date:'HH:mm'}}</span>
                        <ng-container *ngIf="fl.plusDay > 0">
                            <sup>+{{fl.plusDay}}</sup>
                        </ng-container>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Dauer</span>
                        <span multilang>{{fl.dauer}} h</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Flugklasse</span>
                        <span multilang>{{fl.cabinClass}}</span>
                    </div>
                    <div class="f-mobile-info-item-wrapper">
                        <span multilang class="f-mobile-info-item">Gepäck</span>
                        <span multilang>{{fl.gepack}}</span>
                    </div>
                    <ng-container *ngIf="fl.waitTime?.length > 0">
                        <div class="f-mobile-info-item-wrapper">
                            <span multilang class="f-mobile-info-item">Transfer {{fl.arrivalAirport?.code}}</span>
                            <span multilang>{{fl.waitTime}} h</span>
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="k < flugs.length -1">
                    <mat-divider class="mb mt"></mat-divider>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<div class="fixedlefttop">
    <button class="f-b-top" matRipple (click)="sendAnmeldung()">Anfrage senden</button>
</div>